import { selector } from 'recoil';
import { sortBy } from 'lodash';

import { getRegionList } from 'repositories/HttpRepository';

export const getRegions = selector({
  key: 'selector/region/list',
  get: async () => {
    const resp = await getRegionList();
    const data = resp.data;

    return sortBy(
      data?.map(({ properties }) => ({
        label: `[${properties.code}] ${properties.display_name}`,
        value: properties.code,
        timezone: properties.timezone ?? null,
      })) || [],
      'value',
    );
  },
});
